export default __webpack_public_path__ + "static/cover-25de9bbf666ed60f919856790979791a.webp";